import { render, staticRenderFns } from "./AtencionesPantalla.vue?vue&type=template&id=f92b0d20&"
import script from "./AtencionesPantalla.vue?vue&type=script&lang=ts&"
export * from "./AtencionesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports